module.exports = {
    logout: "Abmelden",
    logout_mini: "A"
  }